import script from "./BibleVersionSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./BibleVersionSetting.vue?vue&type=script&lang=ts&setup=true"

import "./BibleVersionSetting.vue?vue&type=style&index=0&id=6db9877c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db9877c"]])

export default __exports__